import React, { useState } from "react";
import { Box } from "@mui/material";
import { motion } from "framer-motion";

const InfiniteMarquee = ({ 
  children, 
  direction = "left", 
  speed = 50,
  pauseOnHover = true 
}) => {
  const [isPaused, setIsPaused] = useState(false);

  const duplicatedChildren = [
    ...React.Children.toArray(children),
    ...React.Children.toArray(children),
  ];

  return (
    <Box
      sx={{
        overflow: "hidden",
        width: "100%",
        position: "relative",
      }}
      onMouseEnter={() => pauseOnHover && setIsPaused(true)}
      onMouseLeave={() => pauseOnHover && setIsPaused(false)}
    >
      <Box
        component={motion.div}
        animate={{
          x: direction === "left" ? ["0%", "-50%"] : ["-50%", "0%"],
        }}
        transition={{
          duration: speed,
          repeat: Infinity,
          ease: "linear",
          ...(isPaused && { duration: 0 }),
        }}
        sx={{
          display: "flex",
          gap: 2,
          width: "fit-content",
        }}
      >
        {duplicatedChildren}
      </Box>
    </Box>
  );
};

export default InfiniteMarquee;